import maid2cleanIcon from './assets/brands/maid2clean-icon.jpg';
import maid2cleanLogo from './assets/brands/maid2clean-logo.png';

/**
 * A business's own look, coded up rather than left to whatever they upload:
 * its logo, its browser-tab icon, and a `data-business` attribute (see
 * refine.css) that swaps the shared Teknika green for its own palette. A slug with no
 * entry here just keeps the default Teknika CRM look, logo and icon included.
 */
const LOGOS: Record<string, string> = {
  maid2clean: maid2cleanLogo,
};

/** Each business's tab icon, taken from its own website. */
const ICONS: Record<string, { href: string; type: string }> = {
  maid2clean: { href: maid2cleanIcon, type: 'image/jpeg' },
};

/** The business's own logo, coded in, unless the office has uploaded a different one. */
export const businessLogo = (slug: string, uploaded: string) => uploaded || LOGOS[slug] || '';

/**
 * Point the page's icon links at the business's icon, or back at Teknika CRM's own.
 * Each link remembers its original href and type the first time, so switching
 * business (or signing out) restores exactly what index.html declared.
 */
function applyIcon(slug: string) {
  const icon = ICONS[slug];
  const links = document.querySelectorAll<HTMLLinkElement>(
    'link[rel="icon"], link[rel="apple-touch-icon"]',
  );
  for (const link of links) {
    link.dataset.defaultHref ??= link.getAttribute('href') ?? '';
    link.dataset.defaultType ??= link.getAttribute('type') ?? '';
    link.href = icon?.href ?? link.dataset.defaultHref;
    const type = icon ? icon.type : link.dataset.defaultType;
    if (type && link.rel === 'icon') link.type = type;
    else link.removeAttribute('type');
  }
}

/** Reflects the signed-in (or slug-known) business's theme onto the page, or clears it back to default. */
export function applyBusinessTheme(slug: string) {
  if (slug in LOGOS) document.documentElement.dataset.business = slug;
  else delete document.documentElement.dataset.business;
  applyIcon(slug);
}
